import { useEffect, useState } from "react";
import { tickerNotices } from "@/mocks/homeContent";

export default function TopBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % tickerNotices.length);
    }, 4500);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 font-label text-[11px] font-medium text-background-50">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-notification-3-line text-xs"></i>
          </span>
          最新动态
        </span>
        <p className="flex-1 truncate text-xs text-background-100 md:text-sm">{tickerNotices[index]}</p>
        <span className="hidden shrink-0 items-center gap-1 text-[11px] text-background-300 md:flex">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-time-line text-xs"></i>
          </span>
          更新于 2025-10-06
        </span>
      </div>
    </div>
  );
}